import React from "react";
import { connect } from "react-redux";
import {
    addLotto5Betting,
    clearCartLotto5,
    deleteLotto5Betting,
    fetchListLotto5Betting,
    fetchLotto5DrawingResult,
    fetchLotto5RecentBetReport,
    fetchLotto5RecentBetReportCache,
    fetchLotto5RecentDraw,
    fetchStatistic5,
    lotto5ConfirmBettingNow,
    setBetStatusLotto5
} from "../../store/lotto5/action";
import { playAudio, setAudio } from "../../store/audio/action";
import { setRenderResultStatus } from "../../store/lotto12/action";
import { fetchUserBalance, fetchUserBalanceValidate, setIsAddToCart, setIsAutoPrint } from "../../store/user/action";
import { getDateHHmmss } from "../../utils/dateUtils";
import _ from "lodash";
import { env } from "../../env";
import betDownAudio from "../../assets/audios/betPlace.mp3";
import winSound from "../../assets/audios/lotto5_win.mp3";
import { clientAp, jackpotNum } from "../../constants/general";
import { getFirstLabel, SUBSCRIPTION_LOTTO5 } from "../../constants/lotto5";
import countdownAudio from "../../assets/audios/countdown.mp3";
import goodLuckAudio from "../../assets/audios/goodluck.mp3";
import stopDrawAudio from "../../assets/audios/drawStop.mp3";
import swal from "sweetalert";
import { getResult } from "../../utils/general";
import { Lotto5Context } from "../../store/lotto5/Lotto5Context";
import { withTranslation } from "react-i18next";
import { getMute5, toggleMute5 } from "../../utils/cached";
import { sessionStore } from "../../utils/storage";
class MainDrawingWrapper extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showBetting: false,
            showDeleteBetting: false,
            betCode: "",
            betAmount: 0,
            betGameType: "",
            betGameOdds: "",
            betGameRange: "",
            betGameTime: "",
            resultItem: null,
            resultItemRandom: null,
            indexResultItem: 0,
            totalResult: null,
            allNumbersDrawing: [],
            classNameNumberDraw: "hide-number-draw",
            classNameLogoRender: "hide-logo-render",
            classCountDown: "total-result-render-count",
            winUO: "",
            winRange: "",
            winOE: "",
            betMessage: "",
            isShowRecentBet: false,
            recentBetDetail: null,
            isShowValidateBalance: false,
            messageValidateBalance: null,
            status: null,
            isStoppedJackpot: true,
            showJackpotValue: false,
            isEnableBetNow: true,
            jackpot: 0,
            // jackpotPlus: 0,
            // showBonus: false
        };
        this.onDrawStatusChange = this.onDrawStatusChange.bind(this);
    }


    onCloseValidateBalance() {
        this.setState({
            isShowValidateBalance: false,
            messageValidateBalance: null
        });
    }

    onBetting = (item) => {
        const { isStopBet, fetchUserBalanceValidate, t } = this.props;
        const { name, value, resultRange, code } = item;
        if (!isStopBet) {
            fetchUserBalanceValidate()
                .then(() => {
                    this.setState({
                        showBetting: true,
                        betGameType: name,
                        betGameOdds: value,
                        betGameRange: resultRange,
                        betCode: code,
                        betGameTime: getDateHHmmss(new Date())
                    });
                }).catch(error => {
                    this.setState({
                        isShowValidateBalance: true,
                        messageValidateBalance: t("labels:common." + error?.response?.data?.message)
                    });
                })
        }
    }

    toggleMute = () => {
        this.setState((preState) => ({
            isMute: preState.isMute === "OFF" ? "ON" : "OFF"
        }), () => toggleMute5(this.state.isMute));
    }

    setWinLose = (indexResultItem) => {
        const { oldResult } = this.props;
        let jp = _.toUpper(oldResult?.rangeCode) === oldResult.jackpotType ? jackpotNum[oldResult.jackpotType] : 0
        this.jackpotInv && clearInterval(this.jackpotInv);
        jp > 0 && this.playAudio(winSound);

        this.setState({
            winUO: _.toUpper(oldResult?.underOverCode),
            winOE: _.toUpper(oldResult?.oddEvenCode),
            winRange: _.toUpper(oldResult?.rangeCode),
            resultItem: null,
            indexResultItem: indexResultItem,
            totalResult: null,
            jackpot: jp,
            classNameNumberDraw: "hide-number-draw",
            classNameLogoRender: "show-logo-render-" + env.PLATFORM_FOR,
            classCountDown: "total-result-render-count"
        });
        // setTimeout(() => {
        //     if (isBonus(oldResult?.bonusCode)) {
        //         this.setState({
        //             showBonus: true,
        //             winUO: "",
        //             winOE: "",
        //             winRange: "",
        //             // jackpotPlus: 0
        //         });
        //         this.randomBonus(oldResult?.bonusCode)
        //     }

        // }, 3000)
    }

    randomBonus = (bonusCode) => {
        this.jackpotInv && clearInterval(this.jackpotInv);
        const bonus = getFirstLabel(bonusCode);

        let num = 0;
        let round = 0;
        let total = 10 + Number(bonus);
        this.jackpotInv = setInterval(() => {
            if (round === total) {
                clearInterval(this.jackpotInv);
                this.setState({ winRange: bonusCode, jackpot: 0 })
            } else {
                if (num >= 5) num = 0;
                num += 1;
                round += 1;
                this.setState({
                    jackpot: num,
                });
            }

        }, 300);
    }

    refreshData = () => {
        const stSize = this.props.stSize;
        this.preSetNewGame();
        this.props.fetchLotto5RecentBetReportCache();
        this.props.fetchStatistic5(stSize);
        this.props.fetchUserBalance();
        this.getRecentDraw();
        this.setState({ showJackpotValue: false });
    }

    preSetNewGame = () => {
        if (this.drawingTime) {
            clearInterval(this.drawingTime);
        }
        this.setState({
            winUO: "",
            winRange: "",
            winOE: "",
            resultItem: null,
            indexResultItem: 0,
            totalResult: null,
            showBonus: false,
            jackpotPlus: 0,
            classNameNumberDraw: "hide-number-draw",
            classNameLogoRender: "show-logo-render-" + env.PLATFORM_FOR,
            classCountDown: "total-result-render-count"
        });
        this.props.setRenderResultStatus({ isStopRender: true });
        this.setNewGame();
    }

    setNewGame = () => {
        this.props.fetchLotto5DrawingResult()
            .then(() => {
                if (this.props.countDownTimer > 0) {
                    this.setState({
                        classNameNumberDraw: "hide-number-draw",
                        classNameLogoRender: "show-logo-render-" + env.PLATFORM_FOR,
                        classCountDown: "total-result-render-count"
                    })
                    this.countingSecond(this.props.countDownTimer)
                }
            })
    }

    checkDrawingResult = () => {
        this.props.fetchLotto5DrawingResult()
            .then((data) => {
                const { countDownTimer } = data;
                this.setBettingStatusByTimer(countDownTimer)
                if (countDownTimer > 0) {
                    this.setState({
                        classNameNumberDraw: "hide-number-draw",
                        classNameLogoRender: "show-logo-render-" + env.PLATFORM_FOR,
                        classCountDown: "total-result-render-count"
                    })
                }
                if (countDownTimer > 10) {
                    this.playAudio(betDownAudio)
                } else if (countDownTimer <= 0) {
                    this.setState({
                        classNameNumberDraw: "show-number-draw",
                        classNameLogoRender: "hide-logo-render",
                        classCountDown: "total-result-render-count-total"
                    })
                    this.props.setRenderResultStatus({ isStopRender: false });
                    return this.getReleaseNum();
                }
            }).catch(() => {
                this.setState({ allNumbersDrawing: [] })
            })
    }

    subscription = () => {
        clientAp.subscribe({
            query: SUBSCRIPTION_LOTTO5,
        }).subscribe({
            next: (event) => {
                if (event.data && event.data.v_lotto5_drawing) {
                    let currentDraw = event.data.v_lotto5_drawing[0] || {};
                    this.onDrawStatusChange(currentDraw);
                }
            },
            error: (err) => {
                console.error("err", err);
            }
        });
    }


    getRecentDraw = () => {
        this.props.fetchLotto5RecentDraw()
            .then(() => {
                if (this.props.isStopRender && this.props.lastResult) {
                    const details = this.props.lastResult.details
                    this.setState({ allNumbersDrawing: details })
                }
            })
    }

    componentWillUnmount() {
        this.drawingTime && clearTimeout(this.drawingTime);
        this.random && clearTimeout(this.random);
        this.startDrawing && clearTimeout(this.startDrawing)
        this.jackpotInv && clearInterval(this.jackpotInv);
    }

    clickAmountBetBtn = (amount) => {
        let betAmount = this.state.betAmount || 0;
        this.setState({
            betAmount: parseInt(betAmount.toString()) + amount
        })
    }

    resetDefaultAmount = () => {
        this.setState({ betAmount: 0 })
    }

    changeBetAmount = (e) => {
        const value = e.target.value;
        if (value >= 0 || !isNaN(value) || value === undefined) {
            this.setState({ betAmount: value })
        }
    }

    setBetMessage = (message = "") => {
        this.setState({ betMessage: message })
    }

    getTotalCartAmount = () => {
        return this.props.fetchListLotto5Betting({ isClear: false }) || 0;
    }



    submitBetNow = () => {
        const { isEnableBetNow } = this.state;
        isEnableBetNow && this.props.lotto5ConfirmBettingNow(() => {
            this.setState({ isEnableBetNow: false })
        }).then(() => {
            this.setState({ isEnableBetNow: true })
            this.props.fetchLotto5RecentBetReport().then(() => this.props.user.isAutoPrint && document.getElementById("print-button").click());
            this.props.fetchUserBalance();
        }).catch((error) => {
            const { response } = error;
            this.setState({ isEnableBetNow: true })
            response && swal(response.data.message, { icon: "error", button: "បិទ" });
        })
    }


    onConfirmBettingLotto5 = async (logs) => {
        const { user: { isAddToCart }, newResult } = this.props;
        const {
            betCode,
            betAmount,
            betGameOdds
        } = this.state;
        const data = {
            drawCode: newResult.drawCode,
            betTypeCode: betCode,
            amount: betAmount,
            betLog: logs,
            rebateRate: betGameOdds,
        }
        await this.props.addLotto5Betting(data);
        !isAddToCart && this.submitBetNow();

        this.setState({
            showBetting: false,
            betAmount: 0,
            betGameType: "",
            betGameOdds: "",
            betCode: "",
            betGameRange: "",
            betGameTime: "",
            betMessage: ""
        })
    }

    onCancelBetting = () => {
        this.setState({
            showBetting: false,
            betAmount: 0,
            betGameType: '',
            betGameOdds: '',
            betMessage: "",
            betGameRange: "",
            betGameTime: ""
        })
    }

    setBettingStatusByTimer = (timerSecond) => {
        const { closeBet, setBetStatusLotto5 } = this.props;
        if (timerSecond <= closeBet && timerSecond > 0) {
            this.setWarningTimer();
            setBetStatusLotto5({ isStopBet: true })
        }
    }

    setWarningTimer = () => this.setState({ classCountDown: "total-result-render-count-warning" });

    countingSecond = (count) => {
        if (this.props.isStopRender) {
            if (this.props.countDownTimer < 0) {
                this.props.setRenderResultStatus({ isStopRender: true })
            } else {
                if (count >= 10) {
                    this.setState({ classCountDown: "total-result-render-count" })
                } else if (count < 10 && count > 0) {
                    this.playAudio(countdownAudio);
                    this.setBettingStatusByTimer(count);
                } else if (count === 0) {
                    if (this.drawingTime) {
                        clearInterval(this.drawingTime);
                    }
                    this.props.clearCartLotto5();
                    this.playAudio(goodLuckAudio)
                    this.props.setRenderResultStatus({ isStopRender: false });
                    this.props.fetchUserBalance()
                    this.setState({ classCountDown: "total-result-render-count-total" })
                }

            }
        }
    }

    getResultDrawing = () => {
        this.props.fetchLotto5DrawingResult()
            .then(() => this.getReleaseNum()).catch(() => {
                this.setState({ allNumbersDrawing: [] });
            })
    }

    getReleaseNum = async () => {
        let { indexNumber, countDownTimer } = this.props;
        if (countDownTimer > 0) countDownTimer = 0;
        let count = Math.abs(countDownTimer);
        if (count <= 3) {
            this.showLoading = setTimeout(() => {
                this.drawResult(0);
                clearTimeout(this.showLoading)
            }, 3000);
            return false;
        } else if (indexNumber <= 20 && indexNumber >= 0) {
            this.drawResult(indexNumber);
        }
    }

    drawResult = (indexNumber) => {
        this.setState({ allNumbersDrawing: [] });
        const result = this.props.oldResult;
        let { totalResult, allNumbersDrawing } = getResult(indexNumber, result)

        this.setState({
            allNumbersDrawing: allNumbersDrawing,
            indexResultItem: indexNumber,
            totalResult: totalResult,
            jackpotPlus: result?.jackpotPlus,
            classNameNumberDraw: "show-number-draw",
            classNameLogoRender: "hide-logo-render"
        }, () => this.showResultRender()
        );

    }


    showResultRender = () => {
        this.random && clearInterval(this.random);
        this.jackpotInv && clearInterval(this.jackpotInv);
        let num = 0;
        if (this.props.oldResult?.jackpot > 1) {
            this.jackpotInv = setInterval(() => {
                if (num >= 5) num = 0;
                num += 1;
                this.setState({
                    jackpot: num,
                });
            }, 800);
        } else {
            this.setState({
                jackpot: 0,
            });
        }

        this.setState({
            classNameNumberDraw: "show-number-draw",
            classNameLogoRender: "hide-logo-render"
        })
        let countSound = 1;
        this.drawingTime &&
            clearInterval(this.drawingTime);

        this.drawingTime = setInterval(() => {
            let indexResultItem = this.state.indexResultItem + 1;
            if (indexResultItem === 21) {
                this.drawingTime && clearInterval(this.drawingTime);
                this.setWinLose(indexResultItem);
            } else if (indexResultItem === 22) {
            } else {
                countSound++;
                if (countSound % 2 === 0) {
                    let resultItem = 1
                    this.random && clearInterval(this.random)
                    this.random = setInterval(() => {
                        if (resultItem === 81) {
                            resultItem = 1
                        }
                        this.setState({ resultItem: resultItem++ })
                    }, 10);
                    this.startDrawing && clearTimeout(this.startDrawing)
                    this.startDrawing = setTimeout(() => {
                        this.random && clearInterval(this.random)
                        let {
                            totalResult,
                            allNumbersDrawing,
                            resultItem
                        } = getResult(indexResultItem, this.props.oldResult);
                        this.playAudio(stopDrawAudio);
                        this.setState({
                            timeCountLotto5: -1,
                            resultItem: resultItem,
                            allNumbersDrawing: allNumbersDrawing,
                            indexResultItem: indexResultItem,
                            totalResult: totalResult,
                            classNameNumberDraw: "show-number-draw"
                        }, () => clearTimeout(this.startDrawing))
                    }, 1000);
                }
            }
        }, 1000
        );
    }

    onShowDetail = (item) => {
        this.setState({
            isShowRecentBet: true,
            recentBetDetail: item
        });
    }

    onCloseDetail = () => {
        this.setState({
            isShowRecentBet: false,
            recentBetDetail: null
        });
    }

    afterPrint = () => {
        this.props.fetchLotto5DrawingResult().then(response => {
            this.setState({
                timeCountLotto5: response.data.data.countDownTimer
            });
        })
    }

    onDrawStatusChange = (currentDraw) => {
        if (currentDraw.status !== this.state.status) {
            if (currentDraw.status === "OPEN" && this.state.status) {
                this.refreshData();
            }
            if (currentDraw.status === "RELEASE") this.getResultDrawing()
            this.setState({ status: currentDraw.status });
            this.verifyCurrentDraw(currentDraw.drawCode)
        }
    }

    verifyCurrentDraw = currentDrawCode => {
        let betList = sessionStore.get("betting_lotto5", []);
        if (betList.length) {
            let firstItem = betList[0];
            if (firstItem.drawCode !== currentDrawCode) {
                this.props.clearCartLotto5();
            }
        }

    }

    playAudio = (src) => {
        const { audio, isIframe, appClass } = this.props;
        if (isIframe && !appClass) {
            if (audio && this.state.isMute === "OFF") playAudio(src);
        } else {
            if (audio && !audio.isMute) playAudio(src);
        }
    };

    listenLocalStorage = () => {
        window.onstorage = () => {
            let mute = getMute5();
            if (mute !== this.state.isMute) {
                this.setState({ isMute: mute });
            }
        }
    }

    componentDidUpdate() {
        if (this.props.isStopBet && this.state.showBetting) {
            this.setState({
                showBetting: false,
                betAmount: 0,
                betGameType: "",
                betGameOdds: "",
                betGameRange: "",
                betGameTime: ""
            })
        }
    }

    componentDidMount() {
        const stSize = this.props.stSize;
        this.subscription();
        this.props.fetchUserBalance();
        this.props.fetchListLotto5Betting({ isClear: true });
        this.checkDrawingResult();
        this.props.fetchLotto5RecentBetReport();
        this.props.fetchStatistic5(stSize);
        this.getRecentDraw();
        this.props.isIframe && this.listenLocalStorage();
    }


    render() {
        // Expose state, methods, and redux props through context
        const contextValue = {
            ...this.state,
            ...this.props, // careful: avoid name conflicts
            // Then add all your methods below
            onCloseValidateBalance: this.onCloseValidateBalance.bind(this),
            onBetting: this.onBetting,
            setWinLose: this.setWinLose,
            randomBonus: this.randomBonus,
            refreshData: this.refreshData,
            preSetNewGame: this.preSetNewGame,
            setNewGame: this.setNewGame,
            checkDrawingResult: this.checkDrawingResult,
            subscription: this.subscription,
            getRecentDraw: this.getRecentDraw,
            clickAmountBetBtn: this.clickAmountBetBtn,
            resetDefaultAmount: this.resetDefaultAmount,
            changeBetAmount: this.changeBetAmount,
            setBetMessage: this.setBetMessage,
            getTotalCartAmount: this.getTotalCartAmount,
            submitBetNow: this.submitBetNow,
            onConfirmBettingLotto5: this.onConfirmBettingLotto5,
            onCancelBetting: this.onCancelBetting,
            setBettingStatusByTimer: this.setBettingStatusByTimer,
            countingSecond: this.countingSecond,
            getResultDrawing: this.getResultDrawing,
            getReleaseNum: this.getReleaseNum,
            drawResult: this.drawResult,
            showResultRender: this.showResultRender,
            onShowDetail: this.onShowDetail,
            onCloseDetail: this.onCloseDetail,
            afterPrint: this.afterPrint,
            onDrawStatusChange: this.onDrawStatusChange,
            verifyCurrentDraw: this.verifyCurrentDraw,
            playAudio: this.playAudio,
            toggleMute: this.toggleMute,
            platform: env.PLATFORM_FOR,
            platformType: env.PLATFORM_TYPE

        };
        return (
            <Lotto5Context.Provider value={contextValue}>
                {this.props.children}
            </Lotto5Context.Provider>
        );
    }
}


const mapStateToProps = state => ({
    ...state.lotto5.draw,
    user: state.user,
    audio: state.audio,
    config: state.config
})


export default withTranslation()(connect(
    mapStateToProps,
    {
        setBetStatusLotto5,
        setAudio,
        setRenderResultStatus,
        addLotto5Betting,
        fetchLotto5RecentDraw,
        fetchLotto5DrawingResult,
        fetchUserBalanceValidate,
        setIsAddToCart,
        clearCartLotto5,
        fetchStatistic5,
        setIsAutoPrint,
        lotto5ConfirmBettingNow,
        fetchLotto5RecentBetReport,
        fetchLotto5RecentBetReportCache,
        deleteLotto5Betting,
        fetchUserBalance,
        fetchListLotto5Betting
    }
)(MainDrawingWrapper))
